// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"89":"news_list","946":"news"}[chunkId] + "." + {"89":"cf2110de","946":"cb9a549b"}[chunkId] + ".js";
};